
import { SnackbarMessage, snackbarMessageKey } from "@/models/symbols/Snackbar";
import { useEventBus } from "@vueuse/core";
import { defineComponent, ref } from "vue";
import BaseAlert from "./BaseAlert.vue";

export default defineComponent({
	components: { BaseAlert },
	setup() {
		const messages = ref<SnackbarMessage[]>([]);

		const close = (id: string) =>
			(messages.value = messages.value.filter((v) => v.id !== id));

		const bus = useEventBus(snackbarMessageKey);

		bus.on((e) => {
			//Avoid duplicate errors (if two api calls fail simultaneously for example)
			if (!messages.value.find((m) => m.message === e.message)) {
				messages.value.push(e);
				setTimeout(() => {
					close(e.id);
				}, 3000);
			}
		});

		return { messages, close };
	},
});
